window.antekaSearchQuery = function (term) {
  const value = term.trim();
  const key = value.toLowerCase().replace(/[أإآ]/g, 'ا').replace(/ى/g, 'ي').replace(/ة/g, 'ه');
  const groups = [
    { terms: ['entree', 'entree table', 'coffee table', 'انترية', 'انتريه', 'انترِيه'], query: 'انترية OR انتريه OR أنتريه OR entree' },
    { terms: ['console', 'كونسول', 'كنسول'], query: 'كنسول OR كونسول OR console' },
    { terms: ['coffee corner', 'كوفي كورنر', 'ركن القهوة'], query: 'كوفي OR ركنة قهوة OR coffee' },
    { terms: ['tv unit', 'tv stand', 'وحدة تلفزيون', 'ترابيزة شاشة'], query: 'شاشة OR تليفزيون OR تلفزيون OR tv' }
  ];
  for (const group of groups) {
    if (group.terms.some(t => t.toLowerCase().replace(/[أإآ]/g, 'ا').replace(/ى/g, 'ي').replace(/ة/g, 'ه') === key)) return group.query;
  }
  return value;
};
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', () => {
        this.input.value = window.antekaSearchQuery(this.input.value);
        let type = this.input.form.querySelector('input[name="type"]');
        if (!type) {
          type = document.createElement('input');
          type.type = 'hidden';
          type.name = 'type';
          this.input.form.appendChild(type);
        }
        type.value = 'product';
      });
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
